// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9939) return "static/chunks/9939-bec3bd3290233692.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"69":"0e33828ece82fa99","1179":"c8d6d835bb59b54a","3662":"ecafa7e9af7fd16c","5811":"9cedc325ac66276d"}[chunkId] + ".js";
};